/**
 * Error handling utilities for consistent error processing across the application
 */

/**
 * Normalizes various error types into a proper Error instance
 * This is particularly useful for Sentry error reporting and consistent error handling
 * 
 * @param {any} error - The error to normalize (Error, object, string, etc.)
 * @returns {Error} - A proper Error instance
 */
export const normalizeError = (error) => {
    // If it's already an Error instance, return it
    if (error instanceof Error) {
        return error;
    }
    
    // If it's an object (like Axios error, API response error, etc.)
    if (error && typeof error === 'object') {
        // Extract the error message from various possible properties
        const errorMessage = error.message || 
                           error.error || 
                           error.errorMessage || 
                           error.msg || 
                           'Unknown error occurred';
        
        // Create a new Error instance
        const normalizedError = new Error(errorMessage);
        
        // Copy over relevant properties that might be useful for debugging
        const propertiesToCopy = [
            'code', 'status', 'statusCode', 'response', 'request', 
            'config', 'stack', 'name', 'type', 'details', 'data'
        ];
        
        propertiesToCopy.forEach(prop => {
            if (error[prop] !== undefined) {
                normalizedError[prop] = error[prop];
            }
        });
        
        return normalizedError;
    }
    
    // If it's a string or other primitive, convert to Error
    return new Error(String(error));
};